"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class2, _temp3; /**
                      * Copyright 2013-present, Novivia, Inc.
                      * All rights reserved.
                      */

var _Carousel = require("react-bootstrap/Carousel");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _CarouselItem = require("react-bootstrap/CarouselItem");

var _CarouselItem2 = _interopRequireDefault(_CarouselItem);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RETRY_INTERVAL = 100;
var MAX_RETRIES = 5;
var PLACEHOLDER_URL = global.__PLACEHOLDER_URL__ || "//s3.amazonaws.com/auctionex-website/assets/img/placeholder_common.jpg";

var LotImage = function (_Component) {
  (0, _inherits3.default)(LotImage, _Component);

  function LotImage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LotImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LotImage.__proto__ || (0, _getPrototypeOf2.default)(LotImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      retries: 0
    }, _this.handleImageError = function (e) {
      var target = e.target;
      _this.setState(function (_ref2) {
        var retries = _ref2.retries;
        return { retries: retries + 1 };
      }, function () {
        var retries = _this.state.retries;
        var url = _this.props.url;


        if (retries > MAX_RETRIES) {
          target.src = PLACEHOLDER_URL;
        } else {
          setTimeout(function () {
            target.src = _this.getFullUrl(url) + "?retry=" + _this.state.retries;
          }, RETRY_INTERVAL);
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // FIXME: Add propTypes.

  (0, _createClass3.default)(LotImage, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.setState({ retries: 0 });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.url !== this.props.url;
    }
  }, {
    key: "getFullUrl",
    value: function getFullUrl(url) {
      if (!url) {
        return PLACEHOLDER_URL;
      }

      return "//" + url;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          url = _props.url,
          responsiveHeight = _props.responsiveHeight,
          onLoad = _props.onLoad;


      return _react2.default.createElement("img", {
        src: this.getFullUrl(url),
        className: (0, _classnames2.default)({
          "img-rounded": true,
          "img-responsive": !responsiveHeight,
          "lot-picture-img": true,
          "lot-picture-img-vertical": responsiveHeight
        }),
        onLoad: onLoad,
        onError: this.handleImageError
        // alt={"Picture #" + index + " of lot " + lotId}
      });
    }
  }]);
  return LotImage;
}(_react.Component);

/**
 * Responsive picture/pictures of a lot.
 * @class
 */


var LotPicture = (_temp3 = _class2 = function (_Component2) {
  (0, _inherits3.default)(LotPicture, _Component2);

  function LotPicture() {
    var _ref3;

    var _temp2, _this2, _ret2;

    (0, _classCallCheck3.default)(this, LotPicture);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = LotPicture.__proto__ || (0, _getPrototypeOf2.default)(LotPicture)).call.apply(_ref3, [this].concat(args))), _this2), _this2.renderPlaceHolder = function () {
      var responsiveHeight = _this2.props.responsiveHeight;


      return _react2.default.createElement(
        "div",
        { className: responsiveHeight ? "max-height" : "" },
        _this2.renderImage()
      );
    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
  }

  (0, _createClass3.default)(LotPicture, [{
    key: "renderImage",


    /**
     * Own methods
     */

    /**
     * Generate the markup necessary to render one image.
     * @param  {string} url   Index of the image to render.
     * @return {ReactElement} React component of the image markup.
     */
    value: function renderImage(url) {
      var _props2 = this.props,
          responsiveHeight = _props2.responsiveHeight,
          onLoad = _props2.onLoad;

      // FIXME: Currently a placeholder image.

      return _react2.default.createElement(LotImage, { responsiveHeight: responsiveHeight, url: url, onLoad: onLoad });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          pictures = _props3.pictures,
          size = _props3.size,
          responsiveHeight = _props3.responsiveHeight,
          props = (0, _objectWithoutProperties3.default)(_props3, ["pictures", "size", "responsiveHeight"]);

      // No picture? Return a placeholder.

      if (!pictures) {
        return this.renderPlaceHolder();
      }

      var pictureList = pictures.filter(function (picture) {
        return !!picture[size];
      });

      // No medium pictures? Return a placeholder.
      if (pictureList.length === 0) {
        return this.renderPlaceHolder();
      }

      // Only return a simple image if there's only one picture for the lot.
      if (pictureList.length === 1) {
        return _react2.default.createElement(
          "div",
          { className: responsiveHeight ? "max-height" : "" },
          this.renderImage(pictureList[0][size])
        );
      }

      // Map images to carousel elements if there are many pictures for the lot.
      return _react2.default.createElement(
        _Carousel2.default,
        (0, _extends3.default)({}, props, {
          className: (0, _classnames2.default)({
            "lot-pictures": true,
            "lot-pictures-responsive-height": responsiveHeight
          })
        }),
        pictureList.map(function (picture) {
          return _react2.default.createElement(
            _CarouselItem2.default,
            { className: "lot-pictures-item" },
            _this3.renderImage(picture[size])
          );
        })
      );
    }
  }]);
  return LotPicture;
}(_react.Component), _class2.propTypes = {
  // List of pictures to display for this lot.
  pictures: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    // URL of medium-sized picture.
    md: _propTypes2.default.string
  })).isRequired,

  // If true, the image responsiveness will be applied using the height rather
  // than the width.
  responsiveHeight: _propTypes2.default.bool,

  // Size to use for the images.
  size: _propTypes2.default.string
}, _class2.defaultProps = {
  size: "md"
}, _temp3);
exports.default = LotPicture;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/LotPicture.jsx
// module id = 853
// module chunks = 15